import { TopicApi, topicsApi } from "api/topics/topicsApi";
import { IDropdownOption } from "components/atoms";
import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";

export const useTopics = (
  skip: number,
  limit: number,
  searchPhrase: string = "",
  filter: string = "",
  orderBy: string = "",
) => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.TOPICS(skip, limit, searchPhrase, filter, orderBy),
    queryFn: () => topicsApi.fetch(skip, limit, searchPhrase, filter, orderBy),
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.TOPICS(skip, limit, searchPhrase, filter, orderBy),
    });
  };

  return { invalidate, isLoading, isFetching, topics: data?.data.data ?? [], total: data?.data.total ?? 0 };
};

export interface TopicOption extends IDropdownOption {
  topic?: TopicApi;
}
export const useTopicsOptions = (addNewTopicOption: boolean = false, filter: string = "") => {
  const { isLoading, topics } = useTopics(0, 1_000_000, "", filter);

  const options: TopicOption[] = topics.map((x) => ({
    value: x.id.toString(),
    label: x.title,
    topic: x,
  }));

  if (addNewTopicOption) options?.unshift({ value: "-1", label: "Dodaj nowy temat" });

  return { loading: isLoading, options };
};
